<template>
  <div v-if="Array.isArray(addresses)">
    <template v-for="address in addresses">
      <address-display
        :key="address.Id"
        :address="address"
        :icon="icon"
      />
    </template>
  </div>
</template>

<script>

import AddressDisplay from '@/components/common/AddressDisplay.vue'

export default {
  name      : 'AddressesDisplay',
  components: {AddressDisplay},
  directives: {},
  mixins    : [],
  props     : {
    addresses: {
      type   : Array,
      default: undefined
    },
    icon: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
